import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import Chart from 'react-apexcharts';
import { useVncTrendMetrics } from '../hooks/useMetrics';
import { generateVncTrendData } from '../utils/dataGenerators';
import { getVncTrendChartOptions } from '../configs/chartConfigs';

const VncTrendChart = ({ chartFilters, selectedManufacturer = 'toyota' }) => {
  const { vncTrendData, loading } = useVncTrendMetrics(selectedManufacturer, chartFilters);
  const chartData = generateVncTrendData(vncTrendData);
  const vncTrendChartOptions = getVncTrendChartOptions(chartData);
  
  return (
    <Card style={{ height: '480px' }}>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span>Vehicle Not Communicating Trend</span>
        <Badge bg="secondary">last 7 days</Badge>
      </Card.Header>
      <Card.Body>
        {!loading && chartData.series[0].data.length > 0 ? (
          <Chart
            options={vncTrendChartOptions}
            series={chartData.series}
            type="line"
            height={400}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center" style={{ height: '400px' }}>
            <span className="text-muted">
              {loading ? 'Loading VNC trend data...' : 'No VNC trend data available'}
            </span>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default VncTrendChart;
